// src/routes.js — every signed-in route, in App.js's order (moved here unchanged from App.js:138-195
// by MGMT-PANEL-BUILD-SHELL-01 so the shell can name each one for the breadcrumb). App.js renders all
// of them inside one <AppShell> layout route; /login stays outside it.
//
// group/title/parent feed the header breadcrumb only. `parent` is the list a detail page belongs to.
import React from 'react';
import Dashboard from './pages/Dashboard';
import Athletes from './pages/Athletes';
import Coaches from './pages/Coaches';
import SiteManagers from './pages/SiteManagers';
import Session from './pages/Session';
import Financials from './pages/Financials';
import Sessions from './pages/Sessions';
import ContentFeed from './pages/ContentFeed';
import Employees from './pages/Employees';
import Athlete from './pages/Athlete';
import Coach from './pages/Coach';
import SiteManager from './pages/SiteManager';
import Employee from './pages/Employee';
import BookingDashboard from './pages/BookingDashboard';
import Waitlist from './pages/Waitlist';
import WaitlistMember from './pages/Waitlist-member';
import Markets from './pages/Markets';
import CountryOverview from './pages/CountryOverview';
import StateOverview from './pages/StateOverview';
import CityOverview from './pages/CityOverview';
import Leads from './pages/Leads';
import Lead from './pages/Lead';
import Applicants from './pages/Applicants';
import ApplicantOverview from './pages/ApplicantOverview';
import FacilitiesCity from './pages/FacilitiesCity';
import FacilityChangelog from './pages/FacilityChangelog';
import FacilitiesRegions from './pages/FacilitiesRegions';
import FacilitiesCountry from './pages/FacilitiesCountry';
import Facilities from './pages/Facilities';
import FacilityDetails from './pages/FacilityDetails';
import Marketing from './pages/Marketing';
import Partner from './pages/Partner';
import PartnersPage from './pages/PartnersPage';
import Outreach from './pages/Outreach';
import ScanHistory from './pages/ScanHistory';
import WhookStream from './pages/WhookStream';
import CreateDemoAccount from './pages/CreateDemoAccount';
import PreferencesPage from './pages/PreferencesPage';
import Upload from './pages/Upload';
import Enterprises from './pages/Enterprises';
import EnterprisePage from './pages/Enterprise';
import Couriers from './pages/Couriers';
import Courier from './pages/Courier';
import ExperiencePricing from './pages/ExperiencePricing';
import GenesisPage from './pages/enterprise-ai/GenesisPage';
import AgentBuilderPage from './pages/enterprise-ai/AgentBuilderPage';
import TranscriptsPage from './pages/enterprise-ai/TranscriptsPage';
import MemoryPage from './pages/enterprise-ai/MemoryPage';
import EvalHarnessPage from './pages/enterprise-ai/EvalHarnessPage';
import OutboundPage from './pages/enterprise-ai/OutboundPage';
import LeadsPage from './pages/enterprise-ai/LeadsPage';
import MoneyPage from './pages/enterprise-ai/MoneyPage';
import PricingPage from './pages/enterprise-ai/PricingPage';

const AI = 'Enterprise AI';
const WS = 'Workspace';

export const SIGNED_IN_ROUTES = [
    // NEW — UNITED FOR BUSINESS / ENTERPRISE
    { path: '/enterprise/:id', element: <EnterprisePage />, group: AI, title: 'Enterprise detail', parent: { to: '/enterprises', label: 'Enterprise' } },

    // ENTERPRISE AI
    { path: '/genesis', element: <GenesisPage />, group: AI, title: 'Genesis' },
    { path: '/agent-builder', element: <AgentBuilderPage />, group: AI, title: 'Agent Builder' },
    { path: '/transcripts', element: <TranscriptsPage />, group: AI, title: 'Transcripts' },
    { path: '/memory', element: <MemoryPage />, group: AI, title: 'Memory' },
    { path: '/eval', element: <EvalHarnessPage />, group: AI, title: 'Eval Harness' },
    { path: '/outbound', element: <OutboundPage />, group: AI, title: 'GTM' },
    { path: '/inbound-leads', element: <LeadsPage />, group: AI, title: 'Leads' },
    { path: '/money', element: <MoneyPage />, group: AI, title: 'Money' },
    { path: '/united-pricing', element: <PricingPage />, group: AI, title: 'Pricing' },

    { path: '/dashboard', element: <Dashboard />, group: WS, title: 'Overview' },
    { path: '/athletes', element: <Athletes />, group: WS, title: 'Users' },
    { path: '/whook', element: <WhookStream />, group: WS, title: 'Whook' },
    { path: '/athlete/:firebaseUid', element: <Athlete />, group: WS, title: 'User', parent: { to: '/athletes', label: 'Users' } },
    { path: '/scanhistory/:partnerId', element: <ScanHistory />, group: WS, title: 'Scan history', parent: { to: '/partners', label: 'Partners' } },
    { path: '/coaches', element: <Coaches />, group: WS, title: 'Instructors' },
    { path: '/coach/:firebaseUid', element: <Coach />, group: WS, title: 'Instructor', parent: { to: '/coaches', label: 'Instructors' } },
    { path: '/facilities', element: <Facilities />, group: WS, title: 'Facilities' },
    { path: '/sitemanagers', element: <SiteManagers />, group: WS, title: 'Site staff' },
    { path: '/preferences', element: <PreferencesPage />, group: WS, title: 'Preferences' },
    { path: '/site-manager/:firebaseUid', element: <SiteManager />, group: WS, title: 'Site staff member', parent: { to: '/sitemanagers', label: 'Site staff' } },
    { path: '/session/:id', element: <Session />, group: WS, title: 'Session', parent: { to: '/sessions', label: 'Sessions' } },
    { path: '/financials', element: <Financials />, group: WS, title: 'Financials' },
    { path: '/countryoverview/:country', element: <CountryOverview />, group: WS, title: 'Country', parent: { to: '/markets', label: 'Markets' } },
    { path: '/facilities/:id', element: <FacilityDetails />, group: WS, title: 'Facility', parent: { to: '/facilities/countries', label: 'Facilities' } },
    { path: '/stateoverview/:state', element: <StateOverview />, group: WS, title: 'State', parent: { to: '/markets', label: 'Markets' } },
    { path: '/facilities/:country/:region/city/', element: <FacilitiesCity />, group: WS, title: 'Cities', parent: { to: '/facilities/countries', label: 'Facilities' } },
    { path: '/facilities/:id/changelog', element: <FacilityChangelog />, group: WS, title: 'Changelog', parent: { to: '/facilities/countries', label: 'Facilities' } },
    { path: '/facilities/:country/regions/', element: <FacilitiesRegions />, group: WS, title: 'Regions', parent: { to: '/facilities/countries', label: 'Facilities' } },
    { path: '/facilities/countries', element: <FacilitiesCountry />, group: WS, title: 'Facilities' },
    { path: '/facilities/:country/:region/:city', element: <Facilities />, group: WS, title: 'Facilities in city', parent: { to: '/facilities/countries', label: 'Facilities' } },
    { path: '/cityoverview/:city', element: <CityOverview />, group: WS, title: 'City', parent: { to: '/markets', label: 'Markets' } },
    { path: '/sessions', element: <Sessions />, group: WS, title: 'Sessions' },
    { path: '/contentfeed', element: <ContentFeed />, group: WS, title: 'Content Feed' },
    { path: '/partners', element: <PartnersPage />, group: WS, title: 'Partners' },
    { path: '/employees', element: <Employees />, group: WS, title: 'Employees' },
    { path: '/partner/:id', element: <Partner />, group: WS, title: 'Partner', parent: { to: '/partners', label: 'Partners' } },
    { path: '/employee/:firebaseUid', element: <Employee />, group: WS, title: 'Employee', parent: { to: '/employees', label: 'Employees' } },
    { path: '/bookingdashboard', element: <BookingDashboard />, group: WS, title: 'Dashboard' },
    { path: '/leads', element: <Leads />, group: WS, title: 'Leads' },
    { path: '/leads/:id', element: <Lead />, group: WS, title: 'Lead', parent: { to: '/leads', label: 'Leads' } },
    { path: '/waitlist', element: <Waitlist />, group: WS, title: 'Waitlist' },
    { path: '/waitlist-member/:id', element: <WaitlistMember />, group: WS, title: 'Waitlist member', parent: { to: '/waitlist', label: 'Waitlist' } },
    { path: '/markets', element: <Markets />, group: WS, title: 'Markets' },
    { path: '/', element: <Dashboard />, group: WS, title: 'Overview' },
    { path: '/applicants', element: <Applicants />, group: WS, title: 'Applicants' },
    { path: '/marketing', element: <Marketing />, group: WS, title: 'Marketing' },
    { path: '/outreach', element: <Outreach />, group: WS, title: 'Outreach' },
    { path: '/applicants/:id', element: <ApplicantOverview />, group: WS, title: 'Applicant', parent: { to: '/applicants', label: 'Applicants' } },
    { path: '/demo', element: <CreateDemoAccount />, group: WS, title: 'Create demo account' },
    { path: '/upload', element: <Upload />, group: WS, title: 'Upload video' },
    { path: '/couriers', element: <Couriers />, group: WS, title: 'Couriers' },
    { path: '/courier/:firebaseUid', element: <Courier />, group: WS, title: 'Courier', parent: { to: '/couriers', label: 'Couriers' } },
    { path: '/enterprises', element: <Enterprises />, group: AI, title: 'Enterprise' },
    { path: '/pricing', element: <ExperiencePricing />, group: WS, title: 'Pricing' },
];
